import { EMPTY_ARRAY } from 'commons-ui';

export const makeActionList = () => {
	return {
		bulkActions: EMPTY_ARRAY,
		rowActions: [
			{
				name: 'Show Changes',
				id: 'showChanges',
				isEnabled: () => {
					return true;
				}
			},
			{
				name: 'Copy Old Object',
				id: 'copyOldObject',
				isEnabled: () => {
					return false;
				}
			},
			{
				name: 'Copy New Object',
				id: 'copyNewObject',
				isEnabled: () => {
					return false;
				}
			}
		]
	};
};

export default {
	makeActionList
};
